import { fetchWithAuth } from './fetchWithAuth'

export async function createTenantGroup(
  token: string,
  body: Record<string, unknown>,
): Promise<void> {
  await fetchWithAuth('/v1/tenant-groups', token, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
